const zipPlus4ToZip = (zipcode) => {
  if (!zipcode) {
    return undefined;
  }

  return zipcode.substring(0, 5);
};

export default zipPlus4ToZip;
